const BASE_URL = import.meta.env.VITE_JOBSOURCE_BASE_URL;

const resetPasswordService = {
  // Sendet eine Passwort-Reset E-Mail an die angegebene E-Mail-Adresse
  sendResetEmail: async (email) => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/auth/reset-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "Fehler beim Senden der Reset-E-Mail"
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Reset email error:", error);
      throw error;
    }
  },

  // Validiert den Reset-Token
  validateResetToken: async (token) => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_BASE_URL}/auth/validate-reset-token`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        return {
          valid: false,
          message: errorData.message || "Token ist ungültig oder abgelaufen",
        };
      }

      const data = await response.json();
      return { valid: true, data };
    } catch (error) {
      console.error("Token validation error:", error);
      return { valid: false, message: "Fehler bei der Token-Validierung" };
    }
  },

  // Setzt das Passwort mit dem gültigen Token zurück
  resetPassword: async (token, newPassword) => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_BASE_URL}/auth/reset-password/confirm`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token,
            newPassword,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "Fehler beim Zurücksetzen des Passworts"
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Password reset error:", error);
      throw error;
    }
  },
};

export default resetPasswordService;
